<script setup lang="ts">
definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/online-zivotopis', de: '/online-lebenslauf', pl: '/cv-online' } })
</script>

<template>
  <MarketingFeaturePage seo-key="onlineCv" path="/online-cv">
      <LazyHomepageSharingSection />
  </MarketingFeaturePage>
</template>
